import { render, staticRenderFns } from "./ReportStaleBanner.vue?vue&type=template&id=4924183c&scoped=true"
import script from "./ReportStaleBanner.vue?vue&type=script&lang=js"
export * from "./ReportStaleBanner.vue?vue&type=script&lang=js"
import style0 from "./ReportStaleBanner.vue?vue&type=style&index=0&id=4924183c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4924183c",
  null
  
)

export default component.exports